import Header from './header/Header';
import Section from './section/Section';

const Home = () => {
    return (
        <div id="home_background">
            <Header />
            <Section />
        </div>
    )
}

export default Home;